/*
 * Purpose: Sync --app-top-offset for toasts + top floating controls below nav chrome
 * Last modified: 2026-06-28 | Agent
 * Completeness: 95
 */
import { useLayoutEffect, type RefObject } from 'react';

const DEFAULT_OFFSET = '12px';

export function useAppTopOffset(chromeRef: RefObject<HTMLElement | null>) {
  useLayoutEffect(() => {
    const el = chromeRef.current;
    if (!el) return;

    let lastOffset = '';

    const sync = () => {
      const bottom = el.getBoundingClientRect().bottom;
      const val = Math.max(0, Math.ceil(bottom));
      const newValue = `${val + 8}px`;
      if (newValue !== lastOffset) {
        lastOffset = newValue;
        document.documentElement.style.setProperty('--app-top-offset', newValue);
      }
    };

    sync();
    const ro = new ResizeObserver(sync);
    ro.observe(el);
    window.addEventListener('resize', sync);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', sync);
      document.documentElement.style.setProperty('--app-top-offset', DEFAULT_OFFSET);
    };
  }, [chromeRef]);
}
